<template>
  <v-app-bar
    width="500"
    height="52"
    app
    color="white"
    :flat="hasprogressBar"
    :elevate-on-scroll="!hasprogressBar"
    :extension-height="extensionHeight"
  >
    <!-- 기본 헤더 시작 -->
    <v-row no-gutters>
      <v-col cols="2" class="d-flex align-center">
        <!-- 뒤로가기 버튼 -->
        <v-btn v-if="hasBackButton" icon small @click="clickBackButton">
          <img src="@/assets/images/icons/btn-chevron-left-weak.svg" />
        </v-btn>
      </v-col>
      <v-col cols="8" class="d-flex justify-center align-center text-center">
        <!-- 페이지 제목 -->
        <v-toolbar-title v-if="title" class="font-size--18 color--gray-100 font-weight-bold">
          {{ title }}
        </v-toolbar-title>
        <!-- 제목없는 경우 로고 -->
        <v-btn
          v-else
          text
          height="24"
          class="px-0 title-logo"
          :ripple="false"
          :to="{ name: 'main' }"
        >
          <img src="@/assets/logo/logo-23.svg" />
        </v-btn>
      </v-col>
      <v-col cols="2" class="d-flex align-center justify-end">
        <!-- 닫기 버튼 -->
        <v-btn v-if="closeAction" icon small @click="closeAction">
          <img src="@/assets/images/icons/btn-close-weak.svg" />
        </v-btn>
      </v-col>
    </v-row>
    <!-- 기본 헤더 끝 -->

    <!-- 확장 헤더 시작 -->
    <template v-slot:extension v-if="hasExtension">
      <!-- 프로세스 진행 바 -->
      <div class="width-100">
        <div v-if="hasprogressBar" class="width-100">
          <v-progress-linear height="2" background-color="#EBEEF2" :buffer-value="progressLength" />
        </div>
      </div>
    </template>
    <!-- 확장 헤더 끝 -->
  </v-app-bar>
</template>

<script>
import { mapState, mapGetters, mapActions } from 'vuex'

export default {
  computed: {
    ...mapState('ui/header', ['backAction', 'closeAction', 'progressLength']),
    ...mapState('auth', ['me']),
    ...mapGetters('auth', ['isAuthenticated']),
    title() {
      return this.$route.meta?.ui?.header?.title
    },
    hasprogressBar() {
      return this.$route.meta?.ui?.header?.progressBar
    },
    hasBackButton() {
      return this.$route.meta?.ui?.header?.backButton
    },
    isMain() {
      return this.$route.path === '/'
    },
    hasExtension() {
      return this.hasprogressBar
    },
    extensionHeight() {
      let height = 0
      if (this.hasprogressBar) height += 2
      // 로그인 헤더 추가
      return height
    },
  },
  methods: {
    ...mapActions('auth', ['signout']),
    clickBackButton() {
      if (this.backAction) {
        this.backAction()
      } else if (!this.isMain) {
        this.$router.go(-1)
      }
    },
    async clickLogout() {
      await this.signout()
      this.$router.replace({
        name: 'signin',
        query: { redirectUri: this.$route.path },
      })
    },
  },
}
</script>

<style lang="scss" scoped>
header {
  font-family: $font-family;
  margin: 0 auto;
}
.v-progress-linear__background {
  left: 15px;
}
::v-deep .v-progress-linear {
  background-color: #ebeef2;

  &__buffer {
    background-color: #202429;
  }
}

.title-logo.v-btn::before {
  opacity: 0;
}
</style>
